import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone: true, name: 'checkoutPipe'})
export class CheckoutPipe implements PipeTransform
{
  transform(checkoutDarts: number, checkouts: number, digits?: number): string
  {
    console.log('checkoutDarts: ' + checkoutDarts + ', checkouts: ' + checkouts);
    if (checkoutDarts > 0)
    {
      if (checkouts > 0)
      {
        const value = checkouts / checkoutDarts;
        return (Math.round(value * 1000) / 10.0).toFixed(digits ?? 0) + ' %';
      }
      else return '0/' + checkoutDarts;
    }
    return '-';
  }
}
